import { render, staticRenderFns } from "./header-dropdown.vue?vue&type=template&id=2587dfd6&scoped=true&"
import script from "./header-dropdown.vue?vue&type=script&lang=js&"
export * from "./header-dropdown.vue?vue&type=script&lang=js&"
import style0 from "./header-dropdown.vue?vue&type=style&index=0&id=2587dfd6&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2587dfd6",
  null
  
)

export default component.exports